import script from "./RankList.vue?vue&type=script&setup=true&lang=js"
export * from "./RankList.vue?vue&type=script&setup=true&lang=js"

import "./RankList.vue?vue&type=style&index=0&id=49248e8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49248e8f"]])

export default __exports__